import { type AxiosInstance } from "axios";

declare module "axios" {
  interface AxiosRequestConfig {
    Region?: string;
  }
}

export function injectRegion(headerName: string = "X-KSC-REGION") {
  return function injectRegionHeader(ins: AxiosInstance) {
    ins.interceptors.request.use(config => {
      const region = config.Region;
      delete config.Region;

      if (region) {
        config.headers.set(headerName, region);
      }

      return config;
    });
    return ins;
  };
}
